import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.find-index";
var dpr = window.devicePixelRatio;
var _imgUrl;

/**
 * 设计提供的规范是基于160dpi下的尺寸
 */
var size = {
  vft_regular: 375,
  vft_large: 630,
  vft_huge: 980,
  vft_max: 1366
};

/**
 * 到2020年1月1日止，所有的苹果设备除了plus下，dpr都是2，plus是3。安卓下是2.x。
 */
export function setSize(imgUrl) {
  var screenWidth = document.documentElement.clientWidth;
  _imgUrl = imgUrl;
  var dpi;
  if (dpr >= 2 && dpr < 3) {
    dpi = 2;
  } else if (dpr >= 3) {
    dpi = 3;
  } else {
    dpi = 1;
  }
  var index = Object.values(size).findIndex(function (el) {
    return el > dpr * screenWidth / dpi;
  }) - 1;
  if (index === -1) {
    index = 0;
  } else if (index === -2) {
    index = Object.values(size).length - 1;
  }
  document.body.classList.remove('vft_regular', 'vft_large', 'vft_huge', 'vft_max');
  document.body.classList.add(Object.keys(size)[index]);
  if (imgUrl && index > 0) {
    setUniverseBg(_imgUrl);
  }
  return Object.keys(size)[index];
}

/**
 * 设置宇宙版背景图，一般情况下设计提供一张2732*808的图，折叠屏尺寸下，背景图为原图的70%，大于折叠屏后，两边留白
 * @param {*} imgUrl
 */
function setUniverseBg(imgUrl) {
  document.documentElement.classList.add('simple_fit');
  var UniverseBgDiv = document.createElement('div');
  UniverseBgDiv.className = 'universe_bg';
  UniverseBgDiv.innerHTML = "<img class=\"universe_bg_img\" src=".concat(imgUrl, ">");
  document.body.style.backgroundColor = '#ececec';
  document.body.appendChild(UniverseBgDiv);
}
window.addEventListener('resize', function () {
  document.body.style.backgroundColor = 'initial';
  var el = document.querySelector('.universe_bg');
  if (el) {
    el.remove();
  }
  setSize(_imgUrl);
});